
import './App.css';
import {store} from './redux_store/store'
import { Modal } from 'antd';
import { Provider } from 'react-redux'
import Routes from './Routes/routes';
import { useEffect,useState } from 'react';
import { ReactQueryDevtools } from 'react-query/devtools'
import {
  QueryClient,
  QueryClientProvider,
} from 'react-query'
function App() {
  const queryClient = new QueryClient()
  const [currentPath,setCurrentPath] = useState(false)
  useEffect(()=>{
    window.addEventListener('storage',()=>{
      if(JSON.parse(localStorage.getItem("loggedUser")) == null){
           if(window.location.pathname != "/login"){
                 window.location = "/login"
           }    
      }
    })

    return  window.removeEventListener('storage', ()=>{
      if(JSON.parse(localStorage.getItem("loggedUser")) == null){
           if(window.location.pathname != "/login"){
                 window.location = "/login"
           }  
      }
    })
  },[])
  return (
    <QueryClientProvider client={queryClient}>
    {/* <Provider store={store}> */}
      <Routes/>
    {/* </Provider> */}
    <Modal title="Basic Modal" visible={currentPath} onOk={()=>{}} onCancel={()=>{}}>
       <p>your Session expired.Please login Again</p>
      </Modal>
    <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
